import { attachmentService } from "client-app-core";
import { createUserFeedback } from "orion-components/Dock/Actions/index.js";
import { getTranslation } from "orion-components/i18n/Actions/index.js";

export const attachFilesToCompositeDevice = (id, entityType = "compositeDevice", files) => {
	return (dispatch) => {
		attachmentService.uploadFiles(id, entityType, files, (err) => {
			if (err) {
				console.error("File upload error:", err);
				dispatch(
					createUserFeedback(
						getTranslation("global.sharedActions.fileUploadFailed", {
							primaryValue: err.message || "An error occurred"
						}),
						null,
						true
					)
				);
				return;
			}
			dispatch(createUserFeedback(getTranslation("global.sharedActions.fileUploadSuccess"), null, false));
		});
	};
};
